import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import BaseDialog from "../base/dialogs/BaseDialog.vue";
import { User } from "@/classes";
import { setupApiQueue } from "../base/api-queue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDialog',
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;

const { queueApiAction, loading } = setupApiQueue();

const dialog = ref(false);
const user = ref<User>(new User());

const open = async (id: string | null) => {
  dialog.value = true;
  if (id) {
    user.value = await User.get(id);
  } else {
    user.value = new User();
  }
};

const save = async () => {
  await queueApiAction(async () => {
    await user.value.save();
  });
  dialog.value = false;
  emits("change");
};

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(BaseDialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialog).value = $event)),
    title: "User"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        loading: !!_unref(loading),
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("Save")
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_text_field, {
        modelValue: user.value.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.email) = $event)),
        label: "Email",
        variant: "outlined",
        density: "compact"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_text_field, {
        modelValue: user.value.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.password) = $event)),
        label: "Password",
        type: "password",
        variant: "outlined",
        density: "compact"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_text_field, {
        modelValue: user.value.first_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.first_name) = $event)),
        label: "First Name",
        variant: "outlined",
        density: "compact"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_text_field, {
        modelValue: user.value.last_name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.last_name) = $event)),
        label: "Last Name",
        variant: "outlined",
        density: "compact"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_checkbox, {
        modelValue: user.value.admin,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.admin) = $event)),
        label: "Admin",
        density: "compact"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})